import { Controller } from "@hotwired/stimulus"

const DURATION = 5000

export default class extends Controller {
  static targets = ["timerBar"]

  connect() {
    this.running = true
    this.timer = setTimeout(() => this.element.remove(), DURATION)

    if (this.hasTimerBarTarget) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.timerBarTarget.style.transform = "scaleX(0)"
        })
      })
    }
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  pause() {
    if (!this.running) return
    this.running = false
    clearTimeout(this.timer)

    if (this.hasTimerBarTarget) {
      const bar = this.timerBarTarget
      const computed = window.getComputedStyle(bar).transform
      bar.style.transition = "none"
      bar.style.transform = computed
      bar.style.opacity = "0"
    }
  }

  close(event) {
    event.stopPropagation()
    clearTimeout(this.timer)
    this.element.remove()
  }
}
